module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"browser_title":"Daily Download Limit Plan"},"ja":{"browser_title":"ダウンロード増量プラン"}}')
  delete Component.options._Ctor
}
